module.exports = {"620104001":"陈坪街道","620104002":"先锋路街道","620104003":"福利路街道","620104004":"西固城街道","620104005":"四季青街道","620104006":"临洮街街道","620104007":"西柳沟街道","620104100":"新城镇","620104101":"东川镇","620104102":"河口镇","620104103":"达川镇","620104104":"柳泉镇","620104204":"金沟乡","620104400":"新安路街道","620104401":"新和路街道"}


//////////////////
// WEBPACK FOOTER
// ./src/town/620104.json
// module id = 2681
// module chunks = 0